



























import { LoaderMixin, StatusEnum } from '@/pages/profile/mixins';
import ConsultationItem from '@/pages/profile/views/consultations/components/ConsultationItem.vue';
import { ERROR_MESSAGE } from '@/pages/profile/views/purchases/types';
import { Slider, Warning } from '@/pages/profile/components';
import { chunk } from 'lodash';

export default {
  name: 'consultations',
  components: { ConsultationItem, Slider, Warning },
  inject: ['$api'],
  mixins: [LoaderMixin],
  metaInfo: () => ({
    title: 'Консультации',
  }),
  data() {
    return {
      items: [],
      errorMessage: 'Сбой в работе оборудования, повторите попытку позже.',
      step: 5,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      try {
        const { data } = await this.$api.get('consultation/get', {
          params: {
            limit: 1000,
            page: 1,
          },
        });
        console.log('consultation/get', data);
        this.items = data.data;
        this.status = StatusEnum.SUCCESS;
      } catch (err) {
        this.processError(err);
      }
    },
    processError(err: any = {}) {
      if (Object.keys(err).length) {
        this.errorMessage =
          Array.isArray(err.errors) && err.errors.length
            ? err.errors[0].msg
            : err.message
            ? err.message
            : ERROR_MESSAGE;
      } else {
        this.errorMessage = ERROR_MESSAGE;
      }
      this.resetData();
      this.status = StatusEnum.ERROR;
    },
  },
  computed: {
    hasItems() {
      return this.items.length > 0;
    },
    isCaruselData() {
      return this.items.length > this.step;
    },
    caruselData() {
      return this.isCaruselData && chunk(this.items, this.step);
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/consultations/Consultatations.vue